module.exports = __webpack_public_path__ + "static/img/sou-s-m@2x.af3b0fcf.png";